(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lt-hero-loop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-lt-hero]');
    if (!roots.length) return;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      var track = root.querySelector('[data-lt-hero-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lt-hero-slide]'));
      var nums = Array.prototype.slice.call(root.querySelectorAll('[data-lt-hero-go]'));
      var prev = root.querySelector('[data-lt-hero-prev]');
      var next = root.querySelector('[data-lt-hero-next]');
      var toggle = root.querySelector('[data-lt-hero-toggle]');
      if (!track || slides.length < 2) return;

      var duration = parseFloat(root.dataset.ltHeroDuration) || 6;
      root.style.setProperty('--lthl-duration', duration + 's');

      var current = 0;
      var paused = reducedMotion;
      var timerId = null;
      var wasPausedByVisibility = false;

      if (paused) {
        root.setAttribute('data-lt-hero-paused', 'true');
        if (toggle) {
          toggle.setAttribute('aria-pressed', 'true');
          toggle.setAttribute('aria-label', 'Reprendre le défilement');
        }
      }

      function clearTimer() {
        if (timerId) { clearTimeout(timerId); timerId = null; }
      }

      function scheduleNext() {
        clearTimer();
        if (paused) return;
        timerId = setTimeout(function () {
          goTo((current + 1) % slides.length, false);
        }, duration * 1000);
      }

      function restartProgress() {
        // Force reflow on the bridge progress after the active number to restart the CSS animation
        var activeNum = root.querySelector('.lt-hero-loop__num.is-active');
        if (!activeNum) return;
        var bridge = activeNum.parentNode.querySelector('.lt-hero-loop__num-bridge');
        if (!bridge) return;
        var progress = bridge.querySelector('.lt-hero-loop__num-progress');
        if (!progress) return;
        progress.style.animation = 'none';
        // eslint-disable-next-line no-unused-expressions
        progress.offsetHeight;
        progress.style.animation = '';
      }

      function goTo(index, fromUser) {
        current = (index + slides.length) % slides.length;
        track.style.transform = 'translate3d(' + (-current * 100) + '%, 0, 0)';
        slides.forEach(function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        nums.forEach(function (num, i) {
          var active = i === current;
          num.classList.toggle('is-active', active);
          num.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        restartProgress();
        scheduleNext();
      }

      function setPaused(value) {
        paused = value;
        if (paused) {
          root.setAttribute('data-lt-hero-paused', 'true');
          clearTimer();
        } else {
          root.removeAttribute('data-lt-hero-paused');
          // Restart progress from current state if user resumes
          restartProgress();
          scheduleNext();
        }
        if (toggle) {
          toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          toggle.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre en pause le défilement');
        }
      }

      // Nav listeners
      if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(current + 1, true); });
      nums.forEach(function (num) {
        num.addEventListener('click', function () {
          var i = parseInt(num.dataset.ltHeroGo, 10) || 0;
          goTo(i, true);
        });
      });
      if (toggle) toggle.addEventListener('click', function () { setPaused(!paused); });

      // Keyboard arrows when section is focused
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { goTo(current - 1, true); }
        else if (e.key === 'ArrowRight') { goTo(current + 1, true); }
      });

      // Swipe tactile : l'image suit le doigt puis snap au slide le plus proche
      var heroAbort = new AbortController();
      var startX = null;
      var dragging = false;
      var dragW = 1;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX;
        dragging = true;
        dragW = (track.parentElement || track).getBoundingClientRect().width || 1;
        track.style.transition = 'none';
        clearTimer();
      }, { signal: heroAbort.signal });
      window.addEventListener('pointermove', function (e) {
        if (!dragging || startX === null) return;
        var dx = e.clientX - startX;
        track.style.transform = 'translate3d(calc(' + (-current * 100) + '% + ' + dx + 'px), 0, 0)';
      }, { signal: heroAbort.signal });
      function ltHeroEndDrag(e) {
        if (!dragging || startX === null) return;
        var dx = (e && e.clientX != null ? e.clientX : startX) - startX;
        dragging = false;
        startX = null;
        track.style.transition = '';
        var threshold = Math.max(40, dragW * 0.15);
        if (dx <= -threshold) { goTo(current + 1, true); }
        else if (dx >= threshold) { goTo(current - 1, true); }
        else { goTo(current, true); }
      }
      window.addEventListener('pointerup', ltHeroEndDrag, { signal: heroAbort.signal });
      window.addEventListener('pointercancel', ltHeroEndDrag, { signal: heroAbort.signal });

      // Auto-pause when offscreen
      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && !paused) {
              wasPausedByVisibility = true;
              clearTimer();
            } else if (entry.isIntersecting && wasPausedByVisibility && !paused) {
              wasPausedByVisibility = false;
              restartProgress();
              scheduleNext();
            }
          });
        }, { threshold: 0.25 });
        io.observe(root);
      }

      // Cleanup au unload (Shopify theme editor reload, navigation SPA)
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(root)) {
          heroAbort.abort();
          clearTimer();
          if (io) io.disconnect();
        }
      });

      scheduleNext();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-langues-check"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if (!root || root.__ltlc) return; root.__ltlc = true;
      function parse(raw){
        return (raw || '').split(',').map(function(x){ var p = x.split('|'); return p.length > 1 ? { f: p[0], n: p[1] } : null; }).filter(Boolean);
      }
      function norm(s){ return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
      function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      var all = parse(root.dataset.langs);
      var popular = parse(root.dataset.popular);
      var CK = '<span class="ltlc__ck"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>';

      // Tuiles : 6 langues distinctes (on retire « (US) », « (Royaume-Uni) »…)
      var seen = {}, tiles = [];
      popular.forEach(function(l){
        var base = l.n.replace(/\s*\(.*\)\s*$/, '');
        if (!seen[base] && tiles.length < 6) { seen[base] = 1; tiles.push({ f: l.f, n: base }); }
      });
      root.querySelector('[data-ltlc-tiles]').innerHTML = tiles.map(function(l){
        return '<div class="ltlc__tile"><span class="ltlc__flag" aria-hidden="true">' + l.f + '</span><span>' + esc(l.n) + '</span><b aria-hidden="true">✓</b></div>';
      }).join('');

      var input = root.querySelector('[data-ltlc-input]');
      var out = root.querySelector('[data-ltlc-answer]');
      input.addEventListener('input', function(){
        var q = norm(input.value.trim());
        if (q.length < 2) { out.innerHTML = ''; return; }
        var m = all.filter(function(l){ return norm(l.n).indexOf(q) !== -1; });
        if (!m.length) {
          out.innerHTML = '<div class="ltlc__none">' + esc(root.dataset.none).replace('{q}', '<b>' + esc(input.value.trim()) + '</b>') + '</div>';
          return;
        }
        out.innerHTML = m.slice(0, 4).map(function(l){
          return '<div class="ltlc__yes"><span class="ltlc__flag" aria-hidden="true">' + l.f + '</span><span>' + esc(l.n) + '<small>' + esc(root.dataset.yes) + '</small></span>' + CK + '</div>';
        }).join('') + (m.length > 4 ? '<div class="ltlc__more">' + esc(root.dataset.more).replace('{n}', m.length - 4) + '</div>' : '');
      });
    }
    document.querySelectorAll('[data-ltlc]').forEach(init);
    document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-ltlc]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-product-coverage-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-lt-product-globe]');
    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const noWebGL = !window.WebGLRenderingContext;
    const conn = navigator.connection || {};
    // `effectiveType` est une estimation de débit, pas le type de réseau : Chrome annonce
    // couramment « 3g » sur une connexion parfaitement correcte. Exclure la 3g privait donc
    // une grande partie des mobiles du globe, qui restaient sur l'image de secours.
    // On ne dégrade plus que sur les débits vraiment faibles, ou si le client demande
    // explicitement d'économiser les données.
    const slowConn = ['slow-2g', '2g'].indexOf(conn.effectiveType) > -1 || conn.saveData === true;
    const lowCpu = (navigator.hardwareConcurrency || 4) < 2;

    if (reducedMotion || noWebGL || slowConn || lowCpu) {
      sections.forEach((s) => s.setAttribute('data-state', 'placeholder-only'));
      return;
    }

    // Liste pays non couverts — DOIT rester synchronisée avec sections/lt-langues-map.liquid
    const UNCOVERED = new Set([
      'Greenland', 'Mongolia', 'Bhutan', 'Myanmar', 'Laos', 'Cambodia',
      'Madagascar', 'Papua New Guinea', 'Vanuatu', 'Solomon Islands',
      'New Caledonia', 'Nauru', 'Tuvalu', 'Kiribati', 'Marshall Islands',
      'Federated States of Micronesia', 'Palau', 'Samoa', 'Tonga', 'Fiji',
      'East Timor', 'Maldives', 'Eritrea', 'South Sudan',
      'Central African Republic', 'Chad', 'Niger', 'Mali', 'Burkina Faso',
      'Guinea', 'Sierra Leone', 'Liberia', 'Guinea Bissau',
      'Somalia', 'Djibouti', 'Rwanda', 'Burundi', 'Malawi',
      'Lesotho', 'Swaziland', 'eSwatini', 'Suriname', 'Guyana'
    ]);

    function isTranslated(feat) {
      const p = feat.properties || {};
      const name = p.NAME || p.name || p.ADMIN || p.admin || '';
      return !UNCOVERED.has(name);
    }

    function loadScript(url) {
      return new Promise((resolve, reject) => {
        if (document.querySelector('script[src="' + url + '"]')) return resolve();
        const s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    const firstSection = sections[0];
    let scriptsPromise = loadScript(firstSection.dataset.threeUrl)
      .then(() => loadScript(firstSection.dataset.globeUrl))
      .catch(() => null);
    let countriesPromise = fetch(firstSection.dataset.countriesUrl)
      .then((r) => r.json())
      .catch(() => null);

    function fallbackToPlaceholder(section) {
      if (section.dataset.state === 'placeholder-only') return;
      section.dataset.state = 'placeholder-only';
      const ph = section.querySelector('[data-lt-pglobe-placeholder]');
      if (ph) ph.setAttribute('aria-hidden', 'false');
      const canvasEl = section.querySelector('[data-lt-pglobe-canvas]');
      if (canvasEl) canvasEl.setAttribute('aria-hidden', 'true');
    }

    function initGlobe(section) {
      const canvasEl = section.querySelector('[data-lt-pglobe-canvas]');
      if (!canvasEl || section.dataset.state === 'ready' || section.dataset.state === 'loading') return;
      section.dataset.state = 'loading';

      // Safety net : si le globe n'a pas atteint "ready" en 8s, on retombe sur le placeholder statique
      const readyTimeout = setTimeout(() => {
        if (section.dataset.state !== 'ready') fallbackToPlaceholder(section);
      }, 8000);

      Promise.all([scriptsPromise, countriesPromise])
        .then(([_, countries]) => {
          if (!countries || !window.Globe || !window.THREE) {
            clearTimeout(readyTimeout);
            fallbackToPlaceholder(section);
            return;
          }

          const violet = getComputedStyle(section).getPropertyValue('--lt-pglobe-violet').trim() || '#4e2778';
          const grey = getComputedStyle(section).getPropertyValue('--lt-pglobe-grey').trim() || '#2a2a32';

          const isMobile = window.matchMedia('(max-width: 768px)').matches;
          const resolution = isMobile ? 2 : 3;
          const autoRotateSpeed = isMobile ? 0.8 : 1.05;

          const feats = countries.features.filter((f) => {
            const name = f.properties.NAME || f.properties.name || '';
            return name !== 'Antarctica';
          });

          const world = window.Globe({ rendererConfig: { powerPreference: 'low-power', antialias: !isMobile } })(canvasEl)
            .backgroundColor('rgba(0,0,0,0)')
            .showGlobe(true)
            .globeMaterial(new window.THREE.MeshBasicMaterial({ color: 0xffffff, transparent: false }))
            .showAtmosphere(false)
            .hexPolygonsData(feats)
            .hexPolygonResolution(resolution)
            .hexPolygonMargin(0.05)
            .hexPolygonUseDots(false)
            .hexPolygonColor((feat) => (isTranslated(feat) ? violet : grey))
            .pointOfView({ lat: 25, lng: 10, altitude: 2.0 });

          // Force pixelRatio max à 1.5 (au lieu de 2-3 sur Retina) → divise par ~2 les pixels à rendre par frame
          try { world.renderer().setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5)); } catch (e) {}

          // Safety net : si WebGL crash en cours de route (context lost / GPU reset), on retombe sur le placeholder
          try {
            const glCanvas = world.renderer().domElement;
            glCanvas.addEventListener('webglcontextlost', (e) => {
              e.preventDefault();
              fallbackToPlaceholder(section);
            }, { once: true });
          } catch (e) {}

          const controls = world.controls();
          controls.autoRotate = true;
          controls.autoRotateSpeed = autoRotateSpeed;
          controls.enableZoom = false;
          controls.enablePan = false;
          controls.enableRotate = false;
          controls.rotateSpeed = isMobile ? 0.45 : 0.6;
          controls.enableDamping = true;
          controls.dampingFactor = 0.12;
          // Le globe est purement décoratif (aucune interaction) : on coupe les contrôles
          // pour laisser le scroll de page passer au doigt. L'auto-rotation continue via update().
          // OrbitControls force "touch-action:none" en inline sur le canvas → on le remet en pan-y.
          controls.enabled = false;
          if (controls.domElement) { controls.domElement.style.touchAction = 'pan-y'; }

          // Reprise auto-rotate après ~2s d'inactivité utilisateur (UX fluide, pas de "spin sauvage")
          let resumeTimer = null;
          controls.addEventListener('start', () => {
            controls.autoRotate = false;
            clearTimeout(resumeTimer);
          });
          controls.addEventListener('end', () => {
            clearTimeout(resumeTimer);
            resumeTimer = setTimeout(() => {
              const rect = section.getBoundingClientRect();
              if (rect.bottom > 0 && rect.top < window.innerHeight) {
                controls.autoRotate = true;
              }
            }, 2000);
          });

          // === Ticker pill : cycle un pays random toutes les ~4.5s (DOM-only, pas de highlight polygon — perf) ===
          const ticker = section.querySelector('[data-lt-pglobe-ticker]');
          let cycleTimer = null;
          let hideTimer = null;

          function flagEmoji(code) {
            if (!code || code.length !== 2 || code === '-9' || code === '-99') return '🌍';
            return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 127397 + c.charCodeAt()));
          }

          function renderTicker(feat) {
            while (ticker.firstChild) ticker.removeChild(ticker.firstChild);
            if (!feat) return;
            const p = feat.properties || {};
            const name = p.NAME_FR || p.name_fr || p.NAME || p.name || p.ADMIN || 'Pays';
            const flag = flagEmoji(p.ISO_A2 || p.iso_a2);
            const trans = isTranslated(feat);
            const flagEl = document.createElement('span');
            flagEl.className = 'lt-pglobe__ticker-flag';
            flagEl.textContent = flag;
            const nameEl = document.createElement('span');
            nameEl.className = 'lt-pglobe__ticker-name';
            nameEl.textContent = name;
            const metaEl = document.createElement('span');
            metaEl.className = 'lt-pglobe__ticker-meta lt-pglobe__ticker-meta--' + (trans ? 'ok' : 'no');
            const dsL = section.dataset;
            metaEl.textContent = trans
              ? (dsL.labelTranslated || 'Traduit') + ' ✓'
              : (dsL.labelNotCovered || 'Non traduit');
            ticker.appendChild(flagEl);
            ticker.appendChild(nameEl);
            ticker.appendChild(metaEl);
          }

          function cycleTicker() {
            const rect = section.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > window.innerHeight) return; // pause hors viewport
            const feat = feats[Math.floor(Math.random() * feats.length)];
            renderTicker(feat);
            ticker.classList.add('lt-pglobe__ticker--show');
            clearTimeout(hideTimer);
            hideTimer = setTimeout(() => {
              ticker.classList.remove('lt-pglobe__ticker--show');
            }, 3000);
          }

          setTimeout(cycleTicker, 1200);
          cycleTimer = setInterval(cycleTicker, 4500);

          function resize() {
            const w = canvasEl.clientWidth, h = canvasEl.clientHeight;
            if (w && h) world.width(w).height(h);
          }
          resize();
          const mapAbort = new AbortController();
          window.addEventListener('resize', resize, { signal: mapAbort.signal });

          const visObs = new IntersectionObserver(
            (entries) => {
              const visible = entries[0].isIntersecting;
              if (!visible) {
                controls.autoRotate = false;
              } else if (resumeTimer == null) {
                // Ne réactive que si l'utilisateur n'est pas en cours d'interaction
                controls.autoRotate = true;
              }
            },
            { threshold: 0.01 }
          );
          visObs.observe(section);

          // Cleanup au unload de la section (theme editor reload, navigation SPA)
          document.addEventListener('shopify:section:unload', function (e) {
            if (e.target && e.target.contains(section)) {
              mapAbort.abort();
              visObs.disconnect();
              if (cycleTimer) clearInterval(cycleTimer);
            }
          });

          requestAnimationFrame(() => {
            clearTimeout(readyTimeout);
            section.dataset.state = 'ready';
            const ph = section.querySelector('[data-lt-pglobe-placeholder]');
            if (ph) ph.setAttribute('aria-hidden', 'true');
            canvasEl.setAttribute('aria-hidden', 'false');
          });
        })
        .catch(() => {
          clearTimeout(readyTimeout);
          fallbackToPlaceholder(section);
        });
    }

    const lazyObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initGlobe(entry.target);
          lazyObs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    sections.forEach((s) => lazyObs.observe(s));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-product-translation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-lt-pf]');
    if (!sections.length) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var viewport = section.querySelector('[data-lt-pf-viewport]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-lt-pf-card]'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-lt-pf-dot]'));
      var prev = section.querySelector('[data-lt-pf-prev]');
      var next = section.querySelector('[data-lt-pf-next]');
      var toggle = section.querySelector('[data-lt-pf-toggle]');
      if (!viewport || cards.length < 2) return;

      var duration = parseFloat(section.dataset.ltPfDuration) || 5;
      var current = 0;
      var timerId = null;
      var paused = reducedMotion;
      var hovering = false;

      if (paused) setPausedFlag(true);

      function setPausedFlag(value) {
        paused = value;
        if (paused) {
          section.setAttribute('data-lt-pf-paused', 'true');
        } else {
          section.removeAttribute('data-lt-pf-paused');
        }
        if (toggle) {
          toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          toggle.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre en pause le défilement');
        }
      }

      function clearTimer() { if (timerId) { clearTimeout(timerId); timerId = null; } }

      function scheduleNext() {
        clearTimer();
        if (paused || hovering) return;
        timerId = setTimeout(function () {
          goTo((current + 1) % cards.length, true);
        }, duration * 1000);
      }

      function goTo(index, smooth) {
        current = (index + cards.length) % cards.length;
        var behavior = (smooth && !reducedMotion) ? 'smooth' : 'auto';
        cards[current].scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'center' });
        syncUI();
        scheduleNext();
      }

      function syncUI() {
        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          dot.setAttribute('tabindex', active ? '0' : '-1');
        });
      }

      // Source de vérité de la carte active : la plus visible dans le viewport
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          });
          if (best && best.isIntersecting) {
            var idx = cards.indexOf(best.target);
            if (idx !== -1 && idx !== current) {
              current = idx;
              syncUI();
            }
          }
        }, { root: viewport, threshold: [0.5, 0.75, 1] });
        cards.forEach(function (card) { io.observe(card); });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.ltPfDot, 10), true);
        });
        dot.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          goTo(current + (e.key === 'ArrowRight' ? 1 : -1), true);
          dots[current].focus();
        });
      });

      if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(current + 1, true); });
      if (toggle) toggle.addEventListener('click', function () {
        setPausedFlag(!paused);
        scheduleNext();
      });

      // Pause au survol (desktop) sans toucher l'état play/pause explicite
      section.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') { hovering = true; clearTimer(); }
      });
      section.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') { hovering = false; scheduleNext(); }
      });

      // Pause hors écran pour la perf
      if ('IntersectionObserver' in window) {
        var visObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) { clearTimer(); }
            else { scheduleNext(); }
          });
        }, { threshold: 0.2 });
        visObserver.observe(section);
      }

      // Reveal au scroll : ajoute .is-inview une fois la section visible, puis on arrête d'observer
      if ('IntersectionObserver' in window) {
        var revealObserver = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-inview');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
        revealObserver.observe(section);
      } else {
        section.classList.add('is-inview');
      }

      syncUI();
      scheduleNext();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-science-research"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.lt-sr:not([data-lt-sr-init])');
    if (!sections.length) return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function attach(section) {
      section.setAttribute('data-lt-sr-init', '1');

      var media = section.querySelector('.lt-sr__media');
      var video = section.querySelector('.lt-sr__video');
      var features = section.querySelectorAll('.lt-sr__feature');

      // Réduction de mouvement : tout est révélé d'emblée, pas de parallax ni lecture auto.
      if (prefersReduced || !('IntersectionObserver' in window)) {
        section.classList.add('lt-sr--visible');
        for (var i = 0; i < features.length; i++) features[i].classList.add('is-in');
        return;
      }

      // 0. Vidéo de l'écouteur : pré-bufferisée + lancée tôt pour éviter le saut
      //    poster → play. Le poster montre la fin de l'animation (vue éclatée),
      //    on veut donc démarrer la vidéo AVANT qu'elle soit dans le viewport.
      if (video) {
        video.muted = true;
        var PLAYBACK_RATE = 1.4;
        try { video.playbackRate = PLAYBACK_RATE; } catch (e) {}

        // Force le préchargement complet dès maintenant.
        try { video.load(); } catch (e) {}

        video.addEventListener('loadedmetadata', function () {
          try { video.playbackRate = PLAYBACK_RATE; } catch (e) {}
        });

        // Déclenche le play QUAND la vidéo s'approche du viewport (200px avant
        // qu'elle entre), pas seulement quand 35% est visible. Comme ça la
        // lecture a déjà démarré quand l'utilisateur voit la zone vidéo.
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              try { video.playbackRate = PLAYBACK_RATE; } catch (e) {}
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              try { video.pause(); } catch (e) {}
            }
          });
        }, { threshold: 0, rootMargin: '200px 0px 200px 0px' });
        videoObserver.observe(video);
      }

      // 1. Révélation de la section (titre, sous-titre, image) à l'entrée.
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('lt-sr--visible');
            sectionObserver.unobserve(section);
          }
        });
      }, { threshold: 0.15 });
      sectionObserver.observe(section);

      // 2. Cascade : chaque bénéfice apparaît quand il croise le bas de l'écran.
      var featureObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            featureObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -12% 0px' });
      for (var j = 0; j < features.length; j++) featureObserver.observe(features[j]);

      // 3. Parallax scrubbé sur l'image éclatée, lié à la position de scroll.
      if (media) {
        var ticking = false;
        var inView = false;

        function update() {
          ticking = false;
          var rect = section.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          // progress : 0 quand la section entre par le bas, 1 quand elle sort par le haut.
          var progress = (vh - rect.top) / (vh + rect.height);
          progress = Math.max(0, Math.min(1, progress));
          var shift = (0.5 - progress) * 64; // ~ +32px → -32px
          media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
        }

        function onScroll() {
          if (!inView || ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        }

        var parallaxObserver = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) onScroll();
        }, { threshold: 0 });
        parallaxObserver.observe(section);

        var abortCtrl = new AbortController();
        window.addEventListener('scroll', onScroll, { passive: true, signal: abortCtrl.signal });
        window.addEventListener('resize', onScroll, { passive: true, signal: abortCtrl.signal });
        update();

        document.addEventListener('shopify:section:unload', function (e) {
          if (e.target && e.target.contains(section)) {
            abortCtrl.abort();
            parallaxObserver.disconnect();
          }
        });
      }
    }

    sections.forEach(attach);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('.lt-sticky-cta');
    if (!btn) return;

    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      btn.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      btn.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
    });

    var footer = document.querySelector('.footer, footer.footer, footer[role="contentinfo"], [id^="shopify-section"][id*="footer"], .lt-footer');

    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var scrolledPast = window.scrollY > Math.max(120, vh * 0.25);
      var shouldHide = false;
      if (footer) {
        var rect = footer.getBoundingClientRect();
        shouldHide = rect.top < vh - 40;
      } else {
        var scrolled = window.scrollY + vh;
        var pct = scrolled / document.documentElement.scrollHeight;
        shouldHide = pct > 0.92;
      }
      btn.classList.toggle('is-visible', scrolledPast && !shouldHide);
      btn.classList.toggle('is-gone', shouldHide);
    }
    update();
    var stickyAbort = new AbortController();
    window.addEventListener('scroll', update, { passive: true, signal: stickyAbort.signal });
    window.addEventListener('resize', update, { signal: stickyAbort.signal });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(btn)) stickyAbort.abort();
    });

    var ucSection = document.querySelector('.lt-uc');
    var ctaActive = false;
    var ctaDx = 0, ctaDy = 0;
    var ctaAnimTimer = null, ctaRaf = 0;

    function getCtaAnchor() {
      if (!ucSection) return null;
      return ucSection.querySelector('.lt-uc__panel.is-active .lt-uc__cta') || ucSection.querySelector('.lt-uc__cta');
    }
    function applyCtaPos() {
      btn.style.setProperty('--cta-dx', ctaDx + 'px');
      btn.style.setProperty('--cta-dy', ctaDy + 'px');
    }
    function computeCtaPos() {
      if (!ctaActive) return;
      var a = getCtaAnchor();
      if (!a) return;
      var aRect = a.getBoundingClientRect();
      if (aRect.width <= 0 || aRect.height <= 0) return;
      var cs = getComputedStyle(btn);
      var bottomPx = parseFloat(cs.bottom) || 24;
      var baseCx = window.innerWidth / 2;
      var baseCy = window.innerHeight - bottomPx - btn.offsetHeight / 2;
      var newDx = (aRect.left + aRect.width / 2) - baseCx;
      var newDy = (aRect.top + aRect.height / 2) - baseCy;
      if (Math.abs(newDx - ctaDx) < 0.5 && Math.abs(newDy - ctaDy) < 0.5) return;
      ctaDx = newDx;
      ctaDy = newDy;
      applyCtaPos();
    }
    function rafTick() {
      if (!ctaActive) { ctaRaf = 0; return; }
      computeCtaPos();
      ctaRaf = requestAnimationFrame(rafTick);
    }
    function startRaf() { if (!ctaRaf) ctaRaf = requestAnimationFrame(rafTick); }
    function setCtaMode(active) {
      if (active === ctaActive) return;
      ctaActive = active;
      if (ctaAnimTimer) { clearTimeout(ctaAnimTimer); ctaAnimTimer = null; }
      btn.classList.add('is-cta-anim');
      if (active) {
        btn.classList.add('is-cta-mode');
        startRaf();
        ctaAnimTimer = setTimeout(function () {
          btn.classList.remove('is-cta-anim');
          ctaAnimTimer = null;
        }, 780);
      } else {
        ctaDx = 0; ctaDy = 0;
        applyCtaPos();
        ctaAnimTimer = setTimeout(function () {
          btn.classList.remove('is-cta-mode');
          btn.classList.remove('is-cta-anim');
          ctaAnimTimer = null;
        }, 780);
      }
    }
    var ctaMql = window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
    var ctaIo = null;
    function initCtaObserver() {
      if (!ucSection || !('IntersectionObserver' in window)) return null;
      if (!ctaMql.matches) return null;
      var entryTarget = ucSection.querySelector('.lt-uc__panel-desc') || ucSection.querySelector('.lt-uc__cta') || ucSection;
      var exitTarget = ucSection.querySelector('.lt-uc__cta') || entryTarget;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var ratio = en.intersectionRatio;
          if (en.target === entryTarget && !ctaActive && en.isIntersecting && ratio >= 0.15) setCtaMode(true);
          if (en.target === exitTarget && ctaActive && ratio < 0.02) setCtaMode(false);
        });
      }, { threshold: [0, 0.02, 0.15, 0.5, 1] });
      io.observe(entryTarget);
      if (exitTarget && exitTarget !== entryTarget) io.observe(exitTarget);
      var seenIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          document.body.classList.toggle('lt-uc-seen', en.isIntersecting);
          if (!en.isIntersecting && ctaActive) setCtaMode(false);
        });
      }, { threshold: 0 });
      seenIo.observe(ucSection);
      return io;
    }
    ctaIo = initCtaObserver();
    if (ctaMql.addEventListener) {
      ctaMql.addEventListener('change', function (e) {
        if (!e.matches) {
          if (ctaActive) setCtaMode(false);
          document.body.classList.remove('lt-uc-seen');
        }
        if (e.matches && !ctaIo) ctaIo = initCtaObserver();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
